import type { ShippingItemSettleStatus } from '../../../modules/api';

// Per-card fulfilment state shown on the Shipping List tile:
//   shipped     → we sent this card
//   unavailable → we couldn't ship it, the player was refunded (FMV + handling)
//   canceled    → bought back when the player canceled the delivery
//   pending     → the warehouse hasn't resolved it yet
// Colours go through --co-ShippingItemStatus-* tokens with hex fallbacks.
const CONFIG: Record<
  'pending' | 'shipped' | 'unavailable' | 'canceled',
  { label: string; bg: string; fg: string }
> = {
  shipped: {
    label: 'Shipped',
    bg: 'var(--co-ShippingItemStatus-shippedBg, rgba(34,225,28,0.18))',
    fg: 'var(--co-ShippingItemStatus-shippedFg, #22E11C)',
  },
  unavailable: {
    label: 'Refunded',
    bg: 'var(--co-ShippingItemStatus-refundedBg, rgba(255,176,32,0.20))',
    fg: 'var(--co-ShippingItemStatus-refundedFg, #FFB020)',
  },
  canceled: {
    label: 'Canceled',
    bg: 'var(--co-ShippingItemStatus-canceledBg, rgba(255,255,255,0.16))',
    fg: 'var(--co-ShippingItemStatus-canceledFg, rgba(255,255,255,0.78))',
  },
  pending: {
    label: 'Processing',
    bg: 'var(--co-ShippingItemStatus-pendingBg, rgba(255,255,255,0.16))',
    fg: 'var(--co-ShippingItemStatus-pendingFg, rgba(255,255,255,0.78))',
  },
};

export function ShippingItemStatusBadge({ status }: { status: ShippingItemSettleStatus }) {
  if (!status) return null;
  const cfg = CONFIG[status];
  if (!cfg) return null;

  return (
    <span
      data-co-component="ShippingItemStatus"
      className="inline-flex items-center rounded-full px-2 py-[3px] text-[11px] font-semibold leading-none backdrop-blur-sm"
      style={{ background: cfg.bg, color: cfg.fg }}
    >
      {cfg.label}
    </span>
  );
}
